module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('div', {
    staticClass: "error-content-block"
  }, [_c('div', {
    staticClass: "error-content"
  }, [_c('i', {
    staticClass: "iconfont icon-caution"
  }), _vm._v(" "), _c('span', [_vm._v("温馨提示"), _c('br'), _vm._v("请先导入数据")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72df3ac4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/error.vue
// module id = 997
// module chunks = 1